import { useQuery } from "react-query";
import inventoryClient from "../clients/inventoryClient";

function useOrderCart(establishmentId) {
    const queryReturnValues = useQuery(
        ["ordercart", { establishmentId }],
        inventoryClient.getEstablishmentOrderCart,
        { refetchOnWindowFocus: false }
    );

   return queryReturnValues;
}

export default useOrderCart;